/* tslint:disable */
/* eslint-disable */
/**
 * Vehicle Data Enrichment API
 * The Vehicle Data Enrichment API delivers enriched data and categorized equipments for stock vehicles.
 *
 * The version of the OpenAPI document: v1.4.0-478.1ea76b
 * Contact: tss-simsearch@daimler.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosInstance, AxiosPromise, AxiosRequestConfig } from 'axios';
// @ts-ignore
import { BASE_PATH, BaseAPI, COLLECTION_FORMATS, RequestArgs, RequiredError } from './base';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  assertParamExists,
  createRequestFunction,
  DUMMY_BASE_URL,
  setApiKeyToObject,
  setSearchParams,
  toPathString,
} from './common';
import { Configuration } from './configuration';

/**
 *
 * @export
 * @interface Attribute
 */
export interface Attribute {
  /**
   *
   * @type {Array<string>}
   * @memberof Attribute
   */
  footnoteRefs?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof Attribute
   */
  formattedValue: string;
  /**
   *
   * @type {string}
   * @memberof Attribute
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Attribute
   */
  name: string;
}
/**
 *
 * @export
 * @interface AttributeCategory
 */
export interface AttributeCategory {
  /**
   *
   * @type {Array<Attribute>}
   * @memberof AttributeCategory
   */
  attributes: Array<Attribute>;
  /**
   *
   * @type {string}
   * @memberof AttributeCategory
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof AttributeCategory
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof AttributeCategory
   */
  sortId?: string;
}
/**
 *
 * @export
 * @interface EnrichedVehicleData
 */
export interface EnrichedVehicleData {
  /**
   *
   * @type {Array<AttributeCategory>}
   * @memberof EnrichedVehicleData
   */
  attributeCategories?: Array<AttributeCategory>;
  /**
   *
   * @type {Array<EquipmentCategory>}
   * @memberof EnrichedVehicleData
   */
  equipmentCategories?: Array<EquipmentCategory>;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof EnrichedVehicleData
   */
  footnotes?: { [key: string]: string };
  /**
   *
   * @type {VehicleIdentification}
   * @memberof EnrichedVehicleData
   */
  identification: VehicleIdentification;
}
/**
 *
 * @export
 * @interface Equipment
 */
export interface Equipment {
  /**
   *
   * @type {string}
   * @memberof Equipment
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof Equipment
   */
  codeType?: string;
  /**
   *
   * @type {string}
   * @memberof Equipment
   */
  description?: string;
  /**
   *
   * @type {Array<EquipmentImages>}
   * @memberof Equipment
   */
  images?: Array<EquipmentImages>;
  /**
   *
   * @type {string}
   * @memberof Equipment
   */
  name?: string;
  /**
   *
   * @types {number}
   * @memberof Equipment
   */
  highlightPriority?: number;
}
/**
 *
 * @export
 * @interface EquipmentCategory
 */
export interface EquipmentCategory {
  /**
   *
   * @type {Array<Equipment>}
   * @memberof EquipmentCategory
   */
  equipments?: Array<Equipment>;
  /**
   *
   * @type {string}
   * @memberof EquipmentCategory
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof EquipmentCategory
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof EquipmentCategory
   */
  sortId?: number;
  /**
   *
   * @type {Array<EquipmentCategory>}
   * @memberof EquipmentCategory
   */
  subcategories?: Array<EquipmentCategory>;
}
/**
 *
 * @export
 * @interface EquipmentImages
 */
export interface EquipmentImages {
  /**
   *
   * @type {string}
   * @memberof EquipmentImages
   */
  name?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof EquipmentImages
   */
  urls?: Array<string>;
}
/**
 *
 * @export
 * @interface VehicleIdentification
 */
export interface VehicleIdentification {
  /**
   *
   * @type {string}
   * @memberof VehicleIdentification
   */
  changeYear?: string;
  /**
   *
   * @type {string}
   * @memberof VehicleIdentification
   */
  commissionNumber?: string;
  /**
   *
   * @type {string}
   * @memberof VehicleIdentification
   */
  model?: string;
  /**
   *
   * @type {string}
   * @memberof VehicleIdentification
   */
  modelYear?: string;
  /**
   *
   * @type {string}
   * @memberof VehicleIdentification
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof VehicleIdentification
   */
  vehicleId?: string;
}

/**
 * GetEnrichedDataForCarConfigurationsApi - axios parameter creator
 * @export
 */
export const GetEnrichedDataForCarConfigurationsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get enriched representation of a car configuration.
     * @param {string} vehicleId VehicleId of the requested car configuration.
     * @param {number} [equipmentCategoryDepth] Max depth of the enriched equipment category structure.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEnrichedCarConfigurationUsingGET: async (
      vehicleId: string,
      equipmentCategoryDepth?: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'vehicleId' is not null or undefined
      assertParamExists('getEnrichedCarConfigurationUsingGET', 'vehicleId', vehicleId);
      const localVarPath = `/v1/carconfigurations/vehicleid/{vehicleId}`.replace(
        `{${'vehicleId'}}`,
        encodeURIComponent(String(vehicleId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKey required
      await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);

      if (equipmentCategoryDepth !== undefined) {
        localVarQueryParameter['equipmentCategoryDepth'] = equipmentCategoryDepth;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * GetEnrichedDataForCarConfigurationsApi - functional programming interface
 * @export
 */
export const GetEnrichedDataForCarConfigurationsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = GetEnrichedDataForCarConfigurationsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get enriched representation of a car configuration.
     * @param {string} vehicleId VehicleId of the requested car configuration.
     * @param {number} [equipmentCategoryDepth] Max depth of the enriched equipment category structure.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEnrichedCarConfigurationUsingGET(
      vehicleId: string,
      equipmentCategoryDepth?: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnrichedVehicleData>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getEnrichedCarConfigurationUsingGET(
        vehicleId,
        equipmentCategoryDepth,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * GetEnrichedDataForCarConfigurationsApi - factory interface
 * @export
 */
export const GetEnrichedDataForCarConfigurationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = GetEnrichedDataForCarConfigurationsApiFp(configuration);
  return {
    /**
     *
     * @summary Get enriched representation of a car configuration.
     * @param {string} vehicleId VehicleId of the requested car configuration.
     * @param {number} [equipmentCategoryDepth] Max depth of the enriched equipment category structure.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEnrichedCarConfigurationUsingGET(
      vehicleId: string,
      equipmentCategoryDepth?: number,
      options?: any,
    ): AxiosPromise<EnrichedVehicleData> {
      return localVarFp
        .getEnrichedCarConfigurationUsingGET(vehicleId, equipmentCategoryDepth, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for getEnrichedCarConfigurationUsingGET operation in GetEnrichedDataForCarConfigurationsApi.
 * @export
 * @interface GetEnrichedDataForCarConfigurationsApiGetEnrichedCarConfigurationUsingGETRequest
 */
export interface GetEnrichedDataForCarConfigurationsApiGetEnrichedCarConfigurationUsingGETRequest {
  /**
   * VehicleId of the requested car configuration.
   * @type {string}
   * @memberof GetEnrichedDataForCarConfigurationsApiGetEnrichedCarConfigurationUsingGET
   */
  readonly vehicleId: string;

  /**
   * Max depth of the enriched equipment category structure.
   * @type {number}
   * @memberof GetEnrichedDataForCarConfigurationsApiGetEnrichedCarConfigurationUsingGET
   */
  readonly equipmentCategoryDepth?: number;
}

/**
 * GetEnrichedDataForCarConfigurationsApi - object-oriented interface
 * @export
 * @class GetEnrichedDataForCarConfigurationsApi
 * @extends {BaseAPI}
 */
export class GetEnrichedDataForCarConfigurationsApi extends BaseAPI {
  /**
   *
   * @summary Get enriched representation of a car configuration.
   * @param {GetEnrichedDataForCarConfigurationsApiGetEnrichedCarConfigurationUsingGETRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GetEnrichedDataForCarConfigurationsApi
   */
  public getEnrichedCarConfigurationUsingGET(
    requestParameters: GetEnrichedDataForCarConfigurationsApiGetEnrichedCarConfigurationUsingGETRequest,
    options?: AxiosRequestConfig,
  ) {
    return GetEnrichedDataForCarConfigurationsApiFp(this.configuration)
      .getEnrichedCarConfigurationUsingGET(
        requestParameters.vehicleId,
        requestParameters.equipmentCategoryDepth,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * GetEnrichedDataForStockVehiclesApi - axios parameter creator
 * @export
 */
export const GetEnrichedDataForStockVehiclesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get enriched representation of a stock vehicle.
     * @param {string} commissionNumber Commission number of the stock vehicle.
     * @param {string} marketId Identifier of the market.
     * @param {number} [equipmentCategoryDepth] Max depth of the enriched equipment category structure.
     * @param {boolean} [newCategoryStructure] New equipment category structure if true, relevant only for market de_DE.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEnrichedStockVehicleUsingGET: async (
      commissionNumber: string,
      marketId: string,
      equipmentCategoryDepth?: number,
      newCategoryStructure?: boolean,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'commissionNumber' is not null or undefined
      assertParamExists('getEnrichedStockVehicleUsingGET', 'commissionNumber', commissionNumber);
      // verify required parameter 'marketId' is not null or undefined
      assertParamExists('getEnrichedStockVehicleUsingGET', 'marketId', marketId);
      const localVarPath = `/v1/stockvehicles/market/{marketId}/commissionnumber/{commissionNumber}`
        .replace(`{${'commissionNumber'}}`, encodeURIComponent(String(commissionNumber)))
        .replace(`{${'marketId'}}`, encodeURIComponent(String(marketId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKey required
      await setApiKeyToObject(localVarHeaderParameter, 'x-api-key', configuration);

      if (equipmentCategoryDepth !== undefined) {
        localVarQueryParameter['equipmentCategoryDepth'] = equipmentCategoryDepth;
      }

      if (newCategoryStructure !== undefined) {
        localVarQueryParameter['newCategoryStructure'] = newCategoryStructure;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * GetEnrichedDataForStockVehiclesApi - functional programming interface
 * @export
 */
export const GetEnrichedDataForStockVehiclesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = GetEnrichedDataForStockVehiclesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get enriched representation of a stock vehicle.
     * @param {string} commissionNumber Commission number of the stock vehicle.
     * @param {string} marketId Identifier of the market.
     * @param {number} [equipmentCategoryDepth] Max depth of the enriched equipment category structure.
     * @param {boolean} [newCategoryStructure] New equipment category structure if true, relevant only for market de_DE.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEnrichedStockVehicleUsingGET(
      commissionNumber: string,
      marketId: string,
      equipmentCategoryDepth?: number,
      newCategoryStructure?: boolean,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnrichedVehicleData>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getEnrichedStockVehicleUsingGET(
        commissionNumber,
        marketId,
        equipmentCategoryDepth,
        newCategoryStructure,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * GetEnrichedDataForStockVehiclesApi - factory interface
 * @export
 */
export const GetEnrichedDataForStockVehiclesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = GetEnrichedDataForStockVehiclesApiFp(configuration);
  return {
    /**
     *
     * @summary Get enriched representation of a stock vehicle.
     * @param {string} commissionNumber Commission number of the stock vehicle.
     * @param {string} marketId Identifier of the market.
     * @param {number} [equipmentCategoryDepth] Max depth of the enriched equipment category structure.
     * @param {boolean} [newCategoryStructure] New equipment category structure if true, relevant only for market de_DE.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEnrichedStockVehicleUsingGET(
      commissionNumber: string,
      marketId: string,
      equipmentCategoryDepth?: number,
      newCategoryStructure?: boolean,
      options?: any,
    ): AxiosPromise<EnrichedVehicleData> {
      return localVarFp
        .getEnrichedStockVehicleUsingGET(
          commissionNumber,
          marketId,
          equipmentCategoryDepth,
          newCategoryStructure,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for getEnrichedStockVehicleUsingGET operation in GetEnrichedDataForStockVehiclesApi.
 * @export
 * @interface GetEnrichedDataForStockVehiclesApiGetEnrichedStockVehicleUsingGETRequest
 */
export interface GetEnrichedDataForStockVehiclesApiGetEnrichedStockVehicleUsingGETRequest {
  /**
   * Commission number of the stock vehicle.
   * @type {string}
   * @memberof GetEnrichedDataForStockVehiclesApiGetEnrichedStockVehicleUsingGET
   */
  readonly commissionNumber: string;

  /**
   * Identifier of the market.
   * @type {string}
   * @memberof GetEnrichedDataForStockVehiclesApiGetEnrichedStockVehicleUsingGET
   */
  readonly marketId: string;

  /**
   * Max depth of the enriched equipment category structure.
   * @type {number}
   * @memberof GetEnrichedDataForStockVehiclesApiGetEnrichedStockVehicleUsingGET
   */
  readonly equipmentCategoryDepth?: number;

  /**
   * New equipment category structure if true, relevant only for market de_DE.
   * @type {boolean}
   * @memberof GetEnrichedDataForStockVehiclesApiGetEnrichedStockVehicleUsingGET
   */
  readonly newCategoryStructure?: boolean;
}

/**
 * GetEnrichedDataForStockVehiclesApi - object-oriented interface
 * @export
 * @class GetEnrichedDataForStockVehiclesApi
 * @extends {BaseAPI}
 */
export class GetEnrichedDataForStockVehiclesApi extends BaseAPI {
  /**
   *
   * @summary Get enriched representation of a stock vehicle.
   * @param {GetEnrichedDataForStockVehiclesApiGetEnrichedStockVehicleUsingGETRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GetEnrichedDataForStockVehiclesApi
   */
  public getEnrichedStockVehicleUsingGET(
    requestParameters: GetEnrichedDataForStockVehiclesApiGetEnrichedStockVehicleUsingGETRequest,
    options?: AxiosRequestConfig,
  ) {
    return GetEnrichedDataForStockVehiclesApiFp(this.configuration)
      .getEnrichedStockVehicleUsingGET(
        requestParameters.commissionNumber,
        requestParameters.marketId,
        requestParameters.equipmentCategoryDepth,
        requestParameters.newCategoryStructure,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
